module.exports = __webpack_public_path__ + "static/media/programme-book.4e4e3d91.png";